var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIHiContrastArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 21,
    viewBox: "0 0 11 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.543L0.5 20.9353L0.500001 0.150664L11 10.543Z",
    fill: "#C4C8CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIHiContrastArrow);
export default __webpack_public_path__ + "static/media/i_hi_contrast_arrow.180061a892301aa50d1676076e5d922a.svg";
export { ForwardRef as ReactComponent };